<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
            <b-overlay :show="formLoader">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form  @submit.prevent="handleSubmit(submit)" @reset.prevent="reset" >
                        <b-row class="mt-4">
                            <b-col sm="12">
                                <ValidationProvider name="Note (En)" vid='note' rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="2"
                                        label-for="note"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('grant_process.note_en')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-textarea
                                            id="note"
                                            v-model="approval.note"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-textarea>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12">
                                <ValidationProvider name="Note (Bn)" vid='note_bn' rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="2"
                                        label-for="note_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('grant_process.note_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-textarea
                                            id="note_bn"
                                            v-model="approval.note_bn"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-textarea>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.save') }}</b-button>
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-1')">{{ $t('globalTrans.cancel') }}</b-button>
                            </div>
                        </div>
                    </b-form>
                </ValidationObserver>
            </b-overlay>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetApprovalNoteApi } from '../../api/routes'
export default {
    props: ['id', 'type'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            formLoader: false,
            getServiceNameList: [],
            approval: {
                note: '',
                note_bn: ''
            }
        }
    },
    methods: {
        async submit () {
            this.formLoader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
            this.approval.type = this.type
            const result = await RestApi.postData(grantAllowanceServiceBaseUrl, budgetApprovalNoteApi + '/' + this.id, this.approval)
            if (result.success) {
                 this.formLoader = false
                this.$toast.success({
                    title: 'Success',
                    message: this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
            } else {
                this.$toast.error({
                    title: 'Error',
                    message: this.$t('globalTrans.form_error_msg'),
                    color: '#D6E09B'
                })
            }
            this.$bvModal.hide('modal-1')
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            this.$emit('load-list')
        }
    }
}
</script>
